<button mat-button>
  <div *ngIf="multiSeletect" class="check-circle">
    <mat-icon svgIcon="check-circle" *ngIf="selected; else uncheck"></mat-icon>
    <ng-template #uncheck>
      <div class="uncheck-circle"></div>
    </ng-template>
  </div>
  <img *ngIf="userImage; else none" src="data:image/png;base64,{{ userImage }}"
    alt="{{ user.name }}" width="56" height="56" />
  <ng-template #none>
    <mat-icon svgIcon="user-avatar"></mat-icon>
  </ng-template>
  <dl class="user-item">
    <dt>{{ user.name }}</dt>
    <dd>
      <span class="kana">{{ user.kana }}</span>
      <span>{{ user.gklv }}</span>
    </dd>
  </dl>
</button>
